import { Component, OnInit, Inject, Input } from '@angular/core';
import { CorrespondenceTimelineService } from '../../../../shared/services/correspondence-timeline.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-archive-timeline-item',
  templateUrl: './archive-timeline-item.component.html',
  styleUrls: ['./archive-timeline-item.component.scss']
})
export class ArchiveTimelineItemComponent implements OnInit {

  @Input() caseId: number;
  @Input() itemIds: number[] = [];

  reason: string = "";
  isLoading: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private correspondenceTimelineService: CorrespondenceTimelineService) {
   }

  ngOnInit(): void {
  }


  archiveItem(){

    this.isLoading = true;

        this.correspondenceTimelineService.archiveItems( this.itemIds, this.caseId, this.reason).subscribe(response => {
          this.activeModal.close(true);
        });

  }
}
